<app-page-meta pageTitle="finzy - Borrower Dashboard"></app-page-meta>
<app-header></app-header>

<div class="container-fluid full-height">
  <div class="row d-flex flex-column align-items-center justify-content-center mt-5">
    <div class="col-xs-12 col-md-9">
      <!-- Gauge meter  -->
      <div *ngIf="creditScore" class="row d-flex justify-content-around">
        <!-- <div class="col">
          <div id="gaugeArea"></div>
        </div> -->
        <div class="row d-flex justify-content-around">
          <div class="col">
            <div class="wrapper">
              <div class="left-value">300</div>
              <div id="gaugeArea"></div>
              <div class="right-value">900</div>
            </div>

          </div>
        </div>
      </div>

      <!-- CIBIL report text  -->
      <div *ngIf="creditScore" class="row d-flex flex-column align-items-center mx-4">
        <div class="col">
          <div class="xx-big-text font-weight-900 color-000">Congratulations!</div>
        </div>
        <div class="col medium-big-text py-3 text-center">
          <span class="text-color-darker-grey">We have successfully generated your CIBIL report and same has been shared
            at your mail id</span>
          <span class="color-000 ml-2">{{email}}</span>
        </div>

        <div class="col medium-text font-weight-bold d-flex flex-md-row flex-column justify-content-center text-center align-items-center">
          <a href="javascript:void(0);" (click)="saveFile()">Download CIBIl Report Summary
            <img alt="download_icon" src="../../../assets/images/download_outlined_icon.svg" />
          </a>
          <img class="ml-md-3" style="width: auto; height: 35px;" alt="cibil_logo" src="../../../assets/images/cibil/powered-by-cibil-logo.png" />
        </div>
        <div *ngIf="creditBureauUniqueReferenceId" class="row mt-3">
          <span class="font-weight-bold text-color-darker-grey">CONTROL NUMBER: {{creditBureauUniqueReferenceId}}</span>
        </div>
      </div>

      <!-- Indicative personal loans  -->
      <app-indicative-loan *ngIf="indicativeLoan" [indicativeLoan]="indicativeLoan" (isApplyNowClicked)="applyNowClicked($event)"></app-indicative-loan>

      <!-- Quick cash personal loans  -->
      <app-quick-cash-loan *ngIf="creditScore" (isQuickCashAvailable)="quickCashAvailabilityCheckForUser($event)"></app-quick-cash-loan>

      <!-- Normal personal loans  -->
      <div *ngIf="showNormalPersonalLoan && !showNoLoanOffer" class="row d-flex p-5 p-md-0 justify-content-center my-5">
        <div class="bordered rounded col-md-12 col-sm-11 col-xs-12 p-0 bg-grey">
          <div class="d-flex p-4">
            <div class="w-100 p-0 d-md-flex align-items-center">
              <div class="px-4 col-lg-10 col-sm-9 col-xs-12">
                <p class="font-weight-bold medium-big-text">
                  Quick personal loans starting at
                  <a href="javascript:void(0);">10.99% p.a.</a>
                </p>
                <div class="d-none d-md-flex">
                  <span>Complete Digitized Processes</span>
                  <span class="text-color-light-grey d-none d-lg-block d-md-block mx-md-4">|</span>
                  <span>No lock-in period</span>
                  <span class="text-color-light-grey d-none d-lg-block d-md-block mx-md-4">|</span>
                  <span>No part payment charges</span>
                </div>
                <div class="d-md-none">
                  <p>Complete Digitized Processes</p>
                  <p>No lock-in period</p>
                  <p>No part payment charges</p>
                </div>
              </div>

              <div class="col-lg-2 col-sm-3 col-xs-12 mt-sm-4 mb-sm-3 pl-lg-0 d-flex justify-content-md-end">
                <button mat-flat-button class="primary p-0 m-0" (click)="applyNowClicked(true)">
                  APPLY NOW
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Normal personal loans with noCibil score  -->
      <div *ngIf="!creditScore" class="row d-flex p-5 p-md-0 flex-column align-items-center">
        <div class="col">
          <img src="../../../assets/images/cibil/data-not-found.svg" alt="data_not_found" />
        </div>
        <div class="col xx-big-text font-weight-900 color-000 mb-md-4">
          <div>Sorry!</div>
        </div>
        <div *ngIf="isNoHistory" class="col text-color-darker-grey font-size-large mb-md-3 text-justify">
          <span>We are unable to locate your information in CIBIL records. Based on the information you have provided during enrollment, we could not locate your credit data in CIBIL records.</span>
        </div>
        <div *ngIf="!isNoHistory" class="col text-color-darker-grey font-size-large mb-md-3 text-justify">
          <span>We are unable to proceed you further with CIBIL journey at this stage.</span>
        </div>
        <div class="bordered rounded col-md-12 col-sm-11 col-xs-12 p-0 bg-grey mt-3">
          <div class="d-flex p-4">
            <div class="w-100 p-0 d-md-flex align-items-center">
              <div class="px-4 col-lg-10 col-sm-9 col-xs-12">
                <p class="font-weight-bold medium-big-text">
                  Quick personal loans starting at
                  <a href="javascript:void(0);">10.99% p.a.</a>
                </p>
                <div class="d-none d-md-flex">
                  <span>Complete Digitized Processes</span>
                  <span class="text-color-light-grey d-none d-lg-block d-md-block mx-md-4">|</span>
                  <span>No lock-in period</span>
                  <span class="text-color-light-grey d-none d-lg-block d-md-block mx-md-4">|</span>
                  <span>No part payment charges</span>
                </div>
                <div class="d-md-none">
                  <p>Complete Digitized Processes</p>
                  <p>No lock-in period</p>
                  <p>No part payment charges</p>
                </div>
              </div>

              <div class="col-lg-2 col-sm-3 col-xs-12 mt-sm-4 mb-sm-3 pl-lg-0 d-flex justify-content-md-end">
                <button mat-flat-button class="primary p-0 m-0" (click)="applyNowClicked(true)">
                  APPLY NOW
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  CIBIL Score-->
    <!-- <div class="col-xs-12 col-md-8 mt-4 overflow-hidden">
      <app-cibil-scores></app-cibil-scores>
    </div> -->
  </div>
</div>

<app-footer></app-footer>